import { BinderView } from '@/models/binder-view.model';
import { HttpClient } from '@angular/common/http';
import { inject, Injectable, signal } from '@angular/core';

import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class BinderViewService {
//inject services
  private http: HttpClient = inject(HttpClient);
  selectedView = signal<BinderView | null>(null);

//signals
  views = signal<BinderView[]>([]);

//constants
  private BASE_URL = environment.landmark_API_URL + "/binderviews";

//constructor
  constructor(
  ) { 
this.getViews();
  }

  getViews() {
    this.http.get<BinderView[]>(this.BASE_URL).subscribe((views) => {
      this.views.set(views);
    });
  }

  updateView(view: BinderView) {
    this.http.post<BinderView>(this.BASE_URL, view).subscribe((view) => {
      this.views.set(this.views().concat(view));
    });
  }

  createView(view: BinderView) {
    this.http.post<BinderView>(this.BASE_URL, view).subscribe((view) => {
      this.views.set(this.views().concat(view));
    });
  }

  deleteView(viewId: number) {
    this.http.delete<BinderView>(`${this.BASE_URL}/${viewId}`).subscribe((view) => {
      this.views.set(this.views().filter((view) => view.viewId !== viewId));
    });
  }
}